import ReactSpeedometer from "react-d3-speedometer"

let minValue = 0;
let maxValue = 140;
const green = '#9ccc65';
const yello = '#ffd54f';
const red = '#ff8f00';
let currentCond=0;
export function OilDegredationMeter({OilCondData}) {

    // currentCond= OilCondData[OilCondData.length-1].oilCondition;

    currentCond=40;
        return (

        Oil2(currentCond)
    )

}
const Oil2 = (value) => (

    <div>
        <ReactSpeedometer
            width={201}
            height={150}
            ringWidth={20}
            needleHeightRatio={0.5}
            forceRender={false}
            maxSegmentLabels={1}
            customSegmentStops={[0,20,40,60,80,100,120,140]}
            segmentColors={[green,green,green, yello,red,red]}
            needleColor={'white'}
            currentValueText={'${value} OD %'}
            minValue={minValue}
            maxValue={maxValue}
            value={value}
            textColor={"white"}
        />
    </div>

)


// width={250}
// height={190}
// ringWidth={20}
// needleHeightRatio={0.5}
// forceRender={false}
// maxSegmentLabels={1}
// customSegmentStops={[-20,0,20,40,60,80,100,120]}
// segmentColors={['#ffd54f', '#9ccc65','#9ccc65','#9ccc65','#9ccc65','#ffd54f','#ff8f00']}
// needleColor={'white'}
// currentValueText={'${value}\u00B0'}
// minValue={-20}
// maxValue={120}
// value={temp}
// textColor={"white"}
